<div class="w-full h-full flex flex-col justify-start items-center overflow-hidden space-y-2">

    <!-- Header -->
    <div
        class="shrink-0 flex flex-row gap-x-4 items-center justify-between w-full border-b border-zinc-200 dark:border-zinc-800 pb-2 pt-1 px-2">
        <div class="flex-1 flex flex-row items-center justify-start gap-x-2">
            <div class="grid grid-cols-1 w-1/5">
                <input id="email" type="email" name="email" placeholder="Keyword Search.."
                    class="col-start-1 row-start-1 block w-full py-1.5 pr-3 pl-10 input-primary-icon"
                    [value]="magicSearchService.searchQuery() ?? ''"
                    (input)="onKeywordSearchInput($any($event.target).value)" />
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="pointer-events-none col-start-1 row-start-1 ml-3 size-5 self-center text-secondary sm:size-4">
                    <path d="m21 21-4.34-4.34" />
                    <circle cx="11" cy="11" r="8" />
                </svg>
            </div>

            <div class="flex flex-row items-center justify-start gap-x-2 overflow-x-auto py-1">
                @let filters = magicSearchService.filtersObjectSignal();
                @if (filters?.searchTerm) {
                <span
                    class="gap-x-0.5 inline-flex items-center rounded-full bg-primary/10 dark:bg-primary/25 px-3 py-1 text-xs font-medium text-accent/90 whitespace-nowrap">
                    Keyword: {{ filters.searchTerm }}
                    <button (click)="removeFilter('searchTerm')" type="button"
                        class="group relative -mr-1 size-3.5 rounded-xs hover:bg-gray-500/20 dark:hover:bg-gray-500/30">
                        <span class="sr-only">Remove</span>
                        <svg viewBox="0 0 14 14"
                            class="size-3.5 stroke-gray-600/50 group-hover:stroke-gray-600/75 dark:stroke-gray-400 dark:group-hover:stroke-gray-300">
                            <path d="M4 4l6 6m0-6l-6 6" />
                        </svg>
                        <span class="absolute -inset-1"></span>
                    </button>
                </span>
                }

                @if (filters?.homeTownSearchTerm) {
                <span
                    class="gap-x-0.5 inline-flex items-center rounded-full bg-sky-100 dark:bg-sky-900/40 px-3 py-1 text-xs font-medium text-sky-700 dark:text-sky-300 whitespace-nowrap">
                    Hometown: {{ filters.homeTownSearchTerm }}
                    <button (click)="removeFilter('homeTownSearchTerm')" type="button"
                        class="group relative -mr-1 size-3.5 rounded-xs hover:bg-gray-500/20 dark:hover:bg-gray-500/30">
                        <span class="sr-only">Remove</span>
                        <svg viewBox="0 0 14 14"
                            class="size-3.5 stroke-gray-600/50 group-hover:stroke-gray-600/75 dark:stroke-gray-400 dark:group-hover:stroke-gray-300">
                            <path d="M4 4l6 6m0-6l-6 6" />
                        </svg>
                        <span class="absolute -inset-1"></span>
                    </button>
                </span>
                }

                @if (filters && filters['country']) {
                <span
                    class="gap-x-0.5 inline-flex items-center rounded-full bg-blue-100 dark:bg-blue-900/40 px-3 py-1 text-xs font-medium text-blue-700 dark:text-blue-300 whitespace-nowrap">
                    Country: {{ $any(filters['country']).name }}
                    <button (click)="removeFilter('country')" type="button"
                        class="group relative -mr-1 size-3.5 rounded-xs hover:bg-gray-500/20 dark:hover:bg-gray-500/30">
                        <span class="sr-only">Remove</span>
                        <svg viewBox="0 0 14 14"
                            class="size-3.5 stroke-gray-600/50 group-hover:stroke-gray-600/75 dark:stroke-gray-400 dark:group-hover:stroke-gray-300">
                            <path d="M4 4l6 6m0-6l-6 6" />
                        </svg>
                        <span class="absolute -inset-1"></span>
                    </button>
                </span>
                }

                @if (filters && filters['gender']) {
                <span
                    class="gap-x-0.5 inline-flex items-center rounded-full bg-primary/10 dark:bg-primary/20 px-3 py-1 text-xs font-medium text-accent whitespace-nowrap">
                    Gender: {{ $any(filters['gender']).name }}
                    <button (click)="removeFilter('gender')" type="button"
                        class="group relative -mr-1 size-3.5 rounded-xs hover:bg-gray-500/20 dark:hover:bg-gray-500/30">
                        <span class="sr-only">Remove</span>
                        <svg viewBox="0 0 14 14"
                            class="size-3.5 stroke-gray-600/50 group-hover:stroke-gray-600/75 dark:stroke-gray-400 dark:group-hover:stroke-gray-300">
                            <path d="M4 4l6 6m0-6l-6 6" />
                        </svg>
                        <span class="absolute -inset-1"></span>
                    </button>
                </span>
                }

                @if (filters && filters['ageOptions']) {
                <span
                    class="gap-x-0.5 inline-flex items-center rounded-full bg-emerald-100 dark:bg-emerald-900/40 px-3 py-1 text-xs font-medium text-emerald-700 dark:text-emerald-300 whitespace-nowrap">
                    Age: {{ $any(filters['ageOptions']).min }} - {{ $any(filters['ageOptions']).max }}
                    <button (click)="removeAgeFilter()" type="button"
                        class="group relative -mr-1 size-3.5 rounded-xs hover:bg-gray-500/20 dark:hover:bg-gray-500/30">
                        <span class="sr-only">Remove</span>
                        <svg viewBox="0 0 14 14"
                            class="size-3.5 stroke-gray-600/50 group-hover:stroke-gray-600/75 dark:stroke-gray-400 dark:group-hover:stroke-gray-300">
                            <path d="M4 4l6 6m0-6l-6 6" />
                        </svg>
                        <span class="absolute -inset-1"></span>
                    </button>
                </span>
                }

                @if (filters && filters['tiktokFollowersRange']) {
                <span
                    class="gap-x-0.5 inline-flex items-center rounded-full bg-pink-100 dark:bg-pink-900/40 px-3 py-1 text-xs font-medium text-pink-700 dark:text-pink-300 whitespace-nowrap">
                    TikTok: {{ formatFollowerRange($any(filters['tiktokFollowersRange'])) }}
                    <button (click)="removeFollowerRangeFilter('tiktok')" type="button"
                        class="group relative -mr-1 size-3.5 rounded-xs hover:bg-gray-500/20 dark:hover:bg-gray-500/30">
                        <span class="sr-only">Remove</span>
                        <svg viewBox="0 0 14 14"
                            class="size-3.5 stroke-gray-600/50 group-hover:stroke-gray-600/75 dark:stroke-gray-400 dark:group-hover:stroke-gray-300">
                            <path d="M4 4l6 6m0-6l-6 6" />
                        </svg>
                        <span class="absolute -inset-1"></span>
                    </button>
                </span>
                }

                @if (filters && filters['instagramFollowersRange']) {
                <span
                    class="gap-x-0.5 inline-flex items-center rounded-full bg-rose-100 dark:bg-rose-900/40 px-3 py-1 text-xs font-medium text-rose-700 dark:text-rose-300 whitespace-nowrap">
                    Instagram: {{ formatFollowerRange($any(filters['instagramFollowersRange'])) }}
                    <button (click)="removeFollowerRangeFilter('instagram')" type="button"
                        class="group relative -mr-1 size-3.5 rounded-xs hover:bg-gray-500/20 dark:hover:bg-gray-500/30">
                        <span class="sr-only">Remove</span>
                        <svg viewBox="0 0 14 14"
                            class="size-3.5 stroke-gray-600/50 group-hover:stroke-gray-600/75 dark:stroke-gray-400 dark:group-hover:stroke-gray-300">
                            <path d="M4 4l6 6m0-6l-6 6" />
                        </svg>
                        <span class="absolute -inset-1"></span>
                    </button>
                </span>
                }

                @if (filters && filters['youtubeSubscribersRange']) {
                <span
                    class="gap-x-0.5 inline-flex items-center rounded-full bg-red-100 dark:bg-red-900/40 px-3 py-1 text-xs font-medium text-red-700 dark:text-red-300 whitespace-nowrap">
                    YouTube: {{ formatFollowerRange($any(filters['youtubeSubscribersRange'])) }}
                    <button (click)="removeFollowerRangeFilter('youtube')" type="button"
                        class="group relative -mr-1 size-3.5 rounded-xs hover:bg-gray-500/20 dark:hover:bg-gray-500/30">
                        <span class="sr-only">Remove</span>
                        <svg viewBox="0 0 14 14"
                            class="size-3.5 stroke-gray-600/50 group-hover:stroke-gray-600/75 dark:stroke-gray-400 dark:group-hover:stroke-gray-300">
                            <path d="M4 4l6 6m0-6l-6 6" />
                        </svg>
                        <span class="absolute -inset-1"></span>
                    </button>
                </span>
                }

                @if (filters && filters['snapchatFollowersRange']) {
                <span
                    class="gap-x-0.5 inline-flex items-center rounded-full bg-yellow-100 dark:bg-yellow-900/40 px-3 py-1 text-xs font-medium text-yellow-700 dark:text-yellow-300 whitespace-nowrap">
                    Snapchat: {{ formatFollowerRange($any(filters['snapchatFollowersRange'])) }}
                    <button (click)="removeFollowerRangeFilter('snapchat')" type="button"
                        class="group relative -mr-1 size-3.5 rounded-xs hover:bg-gray-500/20 dark:hover:bg-gray-500/30">
                        <span class="sr-only">Remove</span>
                        <svg viewBox="0 0 14 14"
                            class="size-3.5 stroke-gray-600/50 group-hover:stroke-gray-600/75 dark:stroke-gray-400 dark:group-hover:stroke-gray-300">
                            <path d="M4 4l6 6m0-6l-6 6" />
                        </svg>
                        <span class="absolute -inset-1"></span>
                    </button>
                </span>
                }

                @if (filters && filters['interests'] && $any(filters['interests']).length) {
                <span
                    class="gap-x-0.5 inline-flex items-center rounded-full bg-fuchsia-100 dark:bg-fuchsia-900/40 px-3 py-1 text-xs font-medium text-fuchsia-700 dark:text-fuchsia-300 whitespace-nowrap">
                    Niches: {{ getInterestsLabel(filters['interests']) }}
                    <button (click)="removeFilter('interests')" type="button"
                        class="group relative -mr-1 size-3.5 rounded-xs hover:bg-gray-500/20 dark:hover:bg-gray-500/30">
                        <span class="sr-only">Remove</span>
                        <svg viewBox="0 0 14 14"
                            class="size-3.5 stroke-gray-600/50 group-hover:stroke-gray-600/75 dark:stroke-gray-400 dark:group-hover:stroke-gray-300">
                            <path d="M4 4l6 6m0-6l-6 6" />
                        </svg>
                        <span class="absolute -inset-1"></span>
                    </button>
                </span>
                }

                @if (filters && filters['sort']) {
                <span
                    class="gap-x-0.5 inline-flex items-center rounded-full bg-slate-100 dark:bg-slate-900/40 px-3 py-1 text-xs font-medium text-slate-700 dark:text-slate-300 whitespace-nowrap">
                    Sort: {{ $any(filters['sort']).name }}
                    <button (click)="removeSortFilter()" type="button"
                        class="group relative -mr-1 size-3.5 rounded-xs hover:bg-gray-500/20 dark:hover:bg-gray-500/30">
                        <span class="sr-only">Remove</span>
                        <svg viewBox="0 0 14 14"
                            class="size-3.5 stroke-gray-600/50 group-hover:stroke-gray-600/75 dark:stroke-gray-400 dark:group-hover:stroke-gray-300">
                            <path d="M4 4l6 6m0-6l-6 6" />
                        </svg>
                        <span class="absolute -inset-1"></span>
                    </button>
                </span>
                }
            </div>
        </div>

        <div class="shrink-0 flex flex-row items-center justify-end gap-x-2">

            @let sortToolbarOptions = magicSearchService.fancyActiveFilters.sortOptions ??
            magicSearchService.activeFilters.sortOptions ?? [];
            @if (sortToolbarOptions.length) {
            <el-select id="creators-v4-sort-select" name="sortSelected" [value]="toolbarSortSelectValue()"
                class="block w-52 min-w-[12rem]">
                <button type="button"
                    class="grid w-full cursor-default grid-cols-1 rounded-md bg-white py-1.5 pr-2 pl-3 text-left text-gray-900 outline-1 -outline-offset-1 outline-gray-300 focus-visible:outline-2 focus-visible:-outline-offset-2 focus-visible:outline-primary sm:text-sm/6 dark:bg-white/5 dark:text-white dark:outline-white/10 dark:focus-visible:outline-primary">
                    <el-selectedcontent class="col-start-1 row-start-1 flex items-center gap-3 pr-6">
                        <div
                            class="shrink-0 p-1 bg-gray-100 dark:bg-gray-700 rounded-full flex items-center justify-center">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" class="size-5">
                                <path d="m3 16 4 4 4-4" />
                                <path d="M7 20V4" />
                                <path d="M11 4h10" />
                                <path d="M11 8h7" />
                                <path d="M11 12h4" />
                            </svg>
                        </div>
                        <span class="block truncate">{{ toolbarSortDisplayName() }}</span>
                    </el-selectedcontent>
                    <svg viewBox="0 0 16 16" fill="currentColor" data-slot="icon" aria-hidden="true"
                        class="col-start-1 row-start-1 size-5 self-center justify-self-end text-gray-500 sm:size-4 dark:text-gray-400">
                        <path
                            d="M5.22 10.22a.75.75 0 0 1 1.06 0L8 11.94l1.72-1.72a.75.75 0 1 1 1.06 1.06l-2.25 2.25a.75.75 0 0 1-1.06 0l-2.25-2.25a.75.75 0 0 1 0-1.06ZM10.78 5.78a.75.75 0 0 1-1.06 0L8 4.06 6.28 5.78a.75.75 0 0 1-1.06-1.06l2.25-2.25a.75.75 0 0 1 1.06 0l2.25 2.25a.75.75 0 0 1 0 1.06Z"
                            clip-rule="evenodd" fill-rule="evenodd" />
                    </svg>
                </button>

                <el-options anchor="bottom start" popover
                    class="max-h-56 overflow-auto rounded-md bg-white py-1 text-base shadow-lg outline-1 outline-black/5 [--anchor-gap:--spacing(1)] data-leave:transition data-leave:transition-discrete data-leave:duration-100 data-leave:ease-in data-closed:data-leave:opacity-0 sm:text-sm dark:bg-gray-800 dark:shadow-none dark:-outline-offset-1 dark:outline-white/10 scrollbar-transparent">
                    @for (sortOption of sortToolbarOptions; track sortOption.id) {
                    <el-option [value]="'' + sortOption.id" (click)="onToolbarSortOptionSelected(sortOption)"
                        class="group/option relative block cursor-default py-2 pr-9 pl-3 text-gray-900 select-none focus:bg-primary focus:text-white focus:outline-hidden dark:text-white dark:focus:bg-primary">
                        <div class="flex flex-col items-stretch text-left">
                            <span class="block truncate font-normal"
                                [class.font-semibold]="isToolbarSortOptionSelected(sortOption)">{{ sortOption.name
                                }}</span>
                            @if (sortOption.description) {
                            <span
                                class="mt-0.5 block text-xs text-gray-500 group-focus/option:text-white dark:text-gray-400 dark:group-focus/option:text-white">{{
                                sortOption.description }}</span>
                            }
                        </div>
                        @if (isToolbarSortOptionSelected(sortOption)) {
                        <span
                            class="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-4 text-accent group-focus/option:text-white">
                            <svg viewBox="0 0 20 20" fill="currentColor" data-slot="icon" aria-hidden="true"
                                class="size-5">
                                <path
                                    d="M16.704 4.153a.75.75 0 0 1 .143 1.052l-8 10.5a.75.75 0 0 1-1.127.075l-4.5-4.5a.75.75 0 0 1 1.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 0 1 1.05-.143Z"
                                    clip-rule="evenodd" fill-rule="evenodd" />
                            </svg>
                        </span>
                        }
                    </el-option>
                    }
                </el-options>
            </el-select>
            }


            <cfv4-filter-drawer></cfv4-filter-drawer>
        </div>
    </div>
    <!-- Header - END -->

    <!-- Main Content -->
    <div class="h-full flex-1 flex-col items-center justify-center w-full overflow-hidden">
        @if (magicSearchService.blueSearchResults() && magicSearchService.blueSearchResults()!.length > 0) {
        <div class="h-full w-full flex flex-col space-y-4 overflow-y-auto scrollbar-transparent"
            (scroll)="onResultsScroll($event)">
            @for (creator of magicSearchService.blueSearchResults()!; track $index) {
            <cv4f-blue-gold-search-item [creator]="creator"
                [monitoringBrief]="monitoringMode() ? manageBriefTabsMonitorService.focussedMonitoringBrief() : undefined"></cv4f-blue-gold-search-item>
            }
        </div>
        } @else if (magicSearchService.blueSearchResults() && magicSearchService.blueSearchResults()!.length == 0) {
        <div class="h-full w-full flex flex-col items-center justify-center py-12 px-4">
            <div class="max-w-lg text-center">
                <div
                    class="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-primary/10 dark:bg-primary/15">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                        class="size-8 text-accent">
                        <path d="M2 21a8 8 0 0 1 11.873-7" />
                        <circle cx="10" cy="8" r="5" />
                        <path d="m17 17 5 5" />
                        <path d="m22 17-5 5" />
                    </svg>
                </div>
                <h3 class="mt-6 text-lg font-semibold text-primary">No creators found</h3>
                @if (hasActiveFilters()) {
                <p class="mt-3 text-sm leading-6 text-secondary">
                    Try updating or clearing some of your filters to see more results.
                </p>
                } @else {
                <p class="mt-3 text-sm leading-6 text-secondary">
                    Try updating or clearing some of your filters to see more results.
                </p>
                }

            </div>
        </div>
        } @else {
        <div class="h-full w-full flex flex-col items-center justify-center">
            <atom-loading-inline [loaderSize]="16" [hideMessage]="true"></atom-loading-inline>
        </div>
        }
    </div>
    <!-- Main Content - END -->
</div>